import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'
export const MarketingTogglesStyle = styled.div<{ borderColor: 'darkAubergine' | 'aubergine' }>`
  margin-top: ${theme.grid.spacing.s}px;
  margin-bottom: ${theme.grid.spacing.base}px;
  width: 100%;
  @media (min-width: ${theme.grid.resolution.mobile.width}px) {
    width: 280px;
  }
  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    width: 388px;
  }
  .toggle {
    height: 59px;
    ${({ borderColor }) => `border-bottom: 1px solid ${theme.tints[borderColor]}`};
    display: flex;
    justify-content: space-between;
    padding-top: ${theme.grid.spacing.s}px;
    &:first-child {
      ${({ borderColor }) => `border-top: 1px solid ${theme.tints[borderColor]}`};
    }
  }
`
